import React from 'react';
import { Button } from '@mui/material';

export const CustomButtonn = ({ children, id, ...props }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const isSuperAdmin = user ? user.superadmin : false;
  const isEnabled = user && user.permissions ? user.permissions.some(permission =>
    permission.includes(id)
  ) : false;



  return (
    <Button {...props} disabled={props.disabled || (!isSuperAdmin && !isEnabled)}>
      {children}
    </Button>
  );
};
